import axios from 'axios';

export default {
  namespaced: true,
  state: {
    geolocations: [],
    isFetching: false,
    isReceiving: false,
    hasAlert: false,
    isDone: false,
    errorMessage: '',
    idToDelete: null,
  },
  mutations: {
    DELETED_GEOLOCATION(state, payload) {
      let indexToDelete = state.geolocations.findIndex(geolocation => geolocation._id === payload._id);
      console.log(indexToDelete);
      let geolocations = [...state.geolocations];
      geolocations.splice(indexToDelete, 1);
      state = Object.assign(state, {
        geolocations: [...geolocations],
        isDeleting: false,
        idToDelete: null,
      });
    },
    DELETING_GEOLOCATION(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload._id;
    },
    RECEIVED_GEOLOCATIONS(state, payload) {
      state.geolocations = payload;
      state.isReceiving = false;
    },
    STOP_RECEIVING(state) {
      state.isReceiving = false;
    },
    RECEIVING_GEOLOCATIONS(state) {
      state.isReceiving = true;
    },
    GEOLOCATION_FAILURE(state, payload) {
      state.isFetching = false;
      state.hasAlert = true;
      state.errorMessage = payload;
    },
    GEOLOCATION_SUCCESS(state) {
      state.isFetching = false;
      state.hasAlert= false;
      state.errorMessage = '';
      state.isDone = true;
    },
    GEOLOCATION_REQUEST(state) {
      state.isFetching = true;
      state.hasAlert= false;
      state.errorMessage = '';
    },
    GEOLOCATION_DONE(state) {
      state.isFetching= false,
      state.hasAlert = false,
      state.isDone = false,
      state.errorMessage = ''
    }
  },
  actions: {
    async getGeolocationsByCustomer({dispatch}, payload) {
      try{
        dispatch("receivingGeolocations");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/geolocation/bycustomer';
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        console.log(response.data);
        dispatch("receiveGeolocations", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getGeolocationsByCustomerSales({dispatch}, payload) {
      try{
        dispatch("receivingGeolocations");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/geolocation/bycustomersales';
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        console.log(response.data);
        dispatch("receiveGeolocations", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getGeolocationsByUser({dispatch}, payload) {
      try{
        dispatch("receivingGeolocations");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/geolocation/byuser';
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        console.log(response.data);
        dispatch("receiveGeolocations", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getGeolocationsBySaleVisits({dispatch}, payload) {
      try{
        dispatch("receivingGeolocations");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/geolocation/bysalevisits';
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        console.log(response.data);
        dispatch("receiveGeolocations", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },

    deletingGeolocation({commit}, payload) {
      commit("DELETING_GEOLOCATION", payload)
    },
    deleteGeolocation({commit}, payload) {
      commit("DELETED_GEOLOCATION", payload)
    },
    receiveGeolocation({dispatch}) {
      dispatch('receiveGeolocationSuccess');
    },
    receiveGeolocations({commit}, payload) {
      commit("RECEIVED_GEOLOCATIONS", payload)
    },
    stopReceiving({commit}, payload) {
      commit("STOP_RECEIVING", payload)
    },
    receivingGeolocations({commit}) {
      commit("RECEIVING_GEOLOCATIONS")
    },
    resetGeolocation({commit}) {
      commit('GEOLOCATION_DONE');
    },
    receiveGeolocationSuccess({commit}) {
      commit('GEOLOCATION_SUCCESS');
    },
    requestGeolocation({commit}) {
      commit('GEOLOCATION_REQUEST');
    },
  }
}
